

import React, { useState, useEffect } from 'react';
import './HeroSection.css';


const HeroSection = () => {
  // Extended sample data with more products
  const allPreorderItems = [
  {
    "id": "novel-1",
    "name": "Nimrod: LostSon(Novel)",
    "price": 1000,
    "type": "novel",
    "image": "/images/novels/nimrod-lostson.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel1.zip",
    "preorderGoal": 2000,
    "preorders": 50,
    "featured": true
  },
  {
    "id": "novel-2",
    "name": "House of Cush(Novel)",
    "price": 1000,
    "type": "novel",
    "image": "/images/novels/house-of-cush.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel2.zip",
    "preorderGoal": 2000,
    "preorders": 50,
    "featured": true
  },
  {
    "id": "novel-3",
    "name": "New Genesis(Novel)",
    "price": 1000,
    "type": "novel",
    "image": "/images/novels/new-genesis.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel3.zip",
    "preorderGoal": 2000,
    "preorders": 65,
    "featured": true
  },
  {
    "id": "novel-4",
    "name": "New Genesis: Return(Novel)",
    "price": 1000,
    "type": "novel",
    "image": "/images/novels/new-genesis-return.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel4.zip",
    "preorderGoal": 2000,
    "preorders": 43,
    "featured": true
  },
  {
    "id": "novel-5",
    "name": "Nimrod: LostSon(Novel)with Soundtrack",
    "price": 1800,
    "type": "novel",
    "image": "/images/novels/nimrod-lostson-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel5.zip",
    "preorderGoal": 2000,
    "preorders": 129,
    "featured": true
  },
  {
    "id": "novel-6",
    "name": "House of Cush(Novel)with Soundtrack",
    "price": 1800,
    "type": "novel",
    "image": "/images/novels/house-of-cush-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel6.zip",
    "preorderGoal": 2000,
    "preorders": 95,
    "featured": true
  },
  {
    "id": "novel-7",
    "name": "New Genesis(Novel)with Soundtrack",
    "price": 1800,
    "type": "novel",
    "image": "/images/novels/new-genesis-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel7.zip",
    "preorderGoal": 2000,
    "preorders": 100,
    "featured": true
  },
  {
    "id": "novel-8",
    "name": "New Genesis: Return(Novel)with Soundtrack",
    "price": 1800,
    "type": "novel",
    "image": "/images/novels/new-genesis-return-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/novels/novel8.zip",
    "preorderGoal": 2000,
    "preorders": 54,
    "featured": true
  },
  {
    "id": "album-1",
    "name": "Christmas Joy(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/christmas-joy.jpg",
"downloadUrl": "https://your-cloud.com/albums/album1.zip",
    "preorderGoal": 10000,
    "preorders": 700,
    "featured": true
  },
  {
    "id": "album-2",
    "name": "Male R&B Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/male-rnb-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album2.zip",
    "preorderGoal": 10000,
    "preorders":200,
    "featured": true
  },
  {
    "id": "album-3",
    "name": "Country Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/country-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album3.zip",
    "preorderGoal": 10000,
    "preorders": 350,
    "featured": true
  },
  {
    "id": "album-4",
    "name": "Adult Sexxy Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/adultsexxy-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album4.zip",
    "preorderGoal": 10000,
    "preorders": 600,
    "featured": true
  },
  {
    "id": "album-5",
    "name": "Girl with Guitars Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/girl-guitars-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album5.zip",
    "preorderGoal":10000,
    "preorders": 800,
    "featured": true
  },
  {
    "id": "album-6",
    "name": "Female R&B Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/female-rnb-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album6.zip",
    "preorderGoal": 10000,
    "preorders": 1200,
    "featured": true
  },
  {
    "id": "album-7",
    "name": "Female Pop Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/female-pop-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album7.zip",
    "preorderGoal": 10000,
    "preorders": 1680,
    "featured": true
  },
  {
    "id": "album-8",
    "name": "Duetz R&B Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/duetz-rnb-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album8.zip",
    "preorderGoal": 10000,
    "preorders": 1876,
    "featured": true
  },
  {
    "id": "album-9",
    "name": "Female2 R&B Hitz(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/female2-rnb-hitz.jpg",
"downloadUrl": "https://your-cloud.com/albums/album9.zip",
    "preorderGoal": 10000,
    "preorders": 900,
    "featured": true
  },
  {
    "id": "album-10",
    "name": "Aphrodite Body(Album)",
    "price": 1000,
    "type": "album",
    "image": "/images/albums/aphrodite-body.jpg",
"downloadUrl": "https://your-cloud.com/albums/album10.zip",
    "preorderGoal": 10000,
    "preorders": 698,
    "featured": true
  },
  {
    "id": "album-11",
    "name": "New Genesis Soundtrack(Album)",
    "price": 1800,
    "type": "album",
    "image": "/images/albums/new-genesis1-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/albums/album11.zip",
    "preorderGoal": 10000,
    "preorders": 1900,
    "featured": true
  },
  {
    "id": "album-12",
    "name": "New Genesis 2 Soundtrack(Album)",
    "price": 1800,
    "type": "album",
    "image": "/images/albums/new-genesis2-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/albums/album12.zip",
    "preorderGoal": 10000,
    "preorders": 999,
    "featured": true
  },
  {
    "id": "album-13",
    "name": "House of Cush Soundtrack(Album)",
    "price": 1800,
    "type": "album",
    "image": "/images/albums/houseofcush-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/albums/album13.zip",
    "preorderGoal": 10000,
    "preorders": 1765,
    "featured": false
  },
  {
    "id": "album-14",
    "name": "Nimrod: LostSon Soundtrack(Album)",
    "price": 1800,
    "type": "album",
    "image": "/images/albums/nimrodlostson-soundtrack.jpg",
"downloadUrl": "https://your-cloud.com/albums/album14.zip",
    "preorderGoal": 10000,
    "preorders": 1309,
    "featured": true
  },
  ];









  const [currentIndex, setCurrentIndex] = useState(0);

if (currentIndex === 0 && allPreorderItems.length === 0) {
  return <div className="loading">Loading preorders...</div>;
}

  // Auto-rotate every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % allPreorderItems.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const PreorderProgressBar = ({ item }) => {
    const progressPercent = Math.min((item.preorders / item.preorderGoal) * 100, 100);
    const progressColor = item.preorders >= item.preorderGoal ? '#007bff' : '#ce0021';

    return (
      <div className="preorder-progress">
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ 
              width: `${progressPercent}%`, 
              backgroundColor: progressColor 
            }}
          />
        </div>
        <span className="progress-text">
          {item.preorders}/{item.preorderGoal} ({progressPercent.toFixed(0)}%)
        </span>
      </div>
    );
  };

  const currentItem = allPreorderItems[currentIndex];

  return (
    <>
      {/* Your existing nav code stays the same */}
   <header className="hero-header">
        <nav className="hero-nav">
          <a href="#home" className="active">Home</a>
          <a href="#albums">Albums</a>
          <a href="#videos">Videos</a>
          <a href="#novels">Novels</a>
          <a href="#art">Art</a>
          <a 
            href="https://mardukson.com/Aboard" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Forum
          </a>
          <a href="#about">About</a>
   <a href="#pricing">Pricing4Site like this</a>          {/* ← ADD THIS */}
    <a href="#demo">Demo Site</a>   
          <a href="#faqs">FAQs</a>
          <a href="#contact">Contact</a>
          <a href="/#featured">Featured Products</a>
         <a href="/store">Store</a>

          {/* → Added Admin link */}
          <a href="/login" className="admin-link">Admin</a>
        </nav>
      </header>














  <section className="hero-section">
  {/* Hero background image handled here */}
  <div className="hero-lights"></div>

  {/* Centered glass panel (existing) */}
  <div className="hero-panel">
    <h1>Welcome to T1Productionz</h1>

  
    {/* ROTATING PREORDER CAROUSEL */}
    <div className="preorder-carousel">
      <h4>🔥 Live Preorders.</h4>
      <div className="carousel-item">
        <div className="preorder-card">
          <div className="preorder-name">{currentItem.name}</div>
          <PreorderProgressBar item={currentItem} />
          <div className="carousel-dots">
            {allPreorderItems.map((_, idx) => (
              <span
                key={idx}
                className={`dot ${idx === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(idx)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    </>
  );
};

export default HeroSection;
